import type { FC } from "react";
import type { ModalProps } from "@uhg-harmony/react";
import { BaseTextInputModal } from "./BaseTextInputModal";

type MoveModalProps = ModalProps & {
  open: boolean;
  onClose: () => void;
  onConfirm?: (folderName: string) => void;
  templateName?: string;
};

export const MoveModal: FC<MoveModalProps> = ({
  title,
  open,
  onClose,
  onConfirm,
  templateName,
}) => (
  <BaseTextInputModal
    title={title}
    open={open}
    onClose={onClose}
    onConfirm={onConfirm}
    templateName={templateName}
    inputLabel="New Template Folder"
    confirmButtonText="Move"
    placeholder=""
  />
);
